import { pickBy } from '@/utils'
import CompHotSetting from "../../comps/comp_hotSetting";
import CompsStyle from "../../comps/comps-style.vue";
import AttrItem from './attr-item.vue';

const HOT_ZONE_MODE = 'hotZone';
const MEMBER_BENEFIT_MODE = 'memberBenefit';
const DISPLAY_MODE_OPTIONS = [
  { name: "显示会员已有优惠券及积分", label: MEMBER_BENEFIT_MODE },
  { name: "设置热区", label: HOT_ZONE_MODE },
];

export default {
  name: 'suspension',
  setting: [
    { label: "楼层", key: "floor_var", component: "input", required: true },
    {
      label: "背景色",
      key: "backgroundColor",
      component: "color",
      value: "#fff",
    },
    {
      label: "背景图",
      key: "backgroundImage",
      component: function (h, { key }) {
        return <SpImagePicker v-model={this.value[key]} size="small" />;
      },
      value: "",
    },
    {
      label: "位置",
      key: "position",
      component: "radiobutton",
      options: [
        { name: "页面顶部", label: "top" },
        { name: "页面底部 ", label: "bottom" },
      ],
      value: "top",
    },
    {
      label: "距离屏幕顶部",
      key: "distance",
      component: "number",
      position: "right",
      size: "mini",
      append: "px",
      min: 0,
      value: 0,
      isShow: function () {
        return this.value.position == 'top'
      }
    },
    {
      label: "距离屏幕底部",
      key: "distance",
      component: "number",
      position: "right",
      size: "mini",
      append: "px",
      min: 0,
      value: 0,
      isShow: function () {
        return this.value.position == 'bottom'
      }
    },
    {
      label: "外边距",
      key: "margin",
      component: function (h, { key }) {
        return (
          <CompsStyle
            showTop={false}
            showBottom={false}
            showBgsetting={false}
            v-model={this.value[key]}
            uuid={this.value.uuid}
            showLabel={false}
          />
        );
      },
      value: {
        paddedr: 0,
        paddedl: 0,
      },
    },
    {
      label: "内边距",
      key: "padding",
      component: function (h, { key }) {
        return (
          <CompsStyle
            showBgsetting={false}
            v-model={this.value[key]}
            uuid={this.value.uuid}
            showLabel={false}
          />
        );
      },
      value: {
        paddedt: 0,
        paddedb: 0,
        paddedl: 0,
        paddedr: 0,
      },
    },{
      label: "是否可关闭",
      key: "isCloseable",
      component: "radiobutton",
      options: [
        { name: "是", label: "yes" },
        { name: "否", label: "no" },
      ],
      value: "no",
    }, {
      label: "关闭后再次显示",
      key: "closeTime",
      component: "number",
      position: "right",
      size: "mini",
      append: "小时",
      min: 1,
      value: 1,
      isShow: function () {
        return this.value.isCloseable == 'yes'
      }
    }, {
      label: "可见范围",
      key: "visibleRange",
      component: function (h, { key, options }) {
        const handleChange = (value) => {
          if (value !== 'vip') {
            if (!this.value.defaultSetting) {
              this.$set(this.value, 'defaultSetting', {});
            }
            this.$set(this.value.defaultSetting, 'displayMode', HOT_ZONE_MODE);
          }
        };
        return (
          <el-radio-group v-model={this.value[key]} size="mini" on-change={handleChange}>
            {options.map(item => <el-radio-button key={item.label} label={item.label}>{item.name}</el-radio-button>)}
          </el-radio-group>
        );
      },
      options: [
        { name: "全部", label: "all" },
        { name: "仅会员", label: "vip" },
        { name: "普通用户", label: "noVip" },
        { name: "不限", label: "none"}
      ],
      value: "all",
    }, {
      label: "内容设置",
      key: "data",
      component: function (h, { key }) {
        return (
          <AttrItem v-model={this.value[key]} uuid={this.value.uuid} />
        );
      },
      value: {
        type: 'vip',
        vip: {
          imgUrl: "", data: [], imgName: '', displayMode: HOT_ZONE_MODE
        },
        noVip: {
          imgUrl: "", data: [], imgName: ''
        }
      },
      isShow: function () {
        return this.value.visibleRange == 'all'
      }
    }, {
      label: "展示方式",
      key: "defaultSettingDisplayMode",
      component: function (h) {
        if (!this.value.defaultSetting) {
          this.$set(this.value, 'defaultSetting', {
            imgUrl: "", data: [], imgName: '', displayMode: HOT_ZONE_MODE
          });
        } else if (!this.value.defaultSetting.displayMode) {
          this.$set(this.value.defaultSetting, 'displayMode', HOT_ZONE_MODE);
        }
        return (
          <el-radio-group v-model={this.value.defaultSetting.displayMode} size="mini">
            {DISPLAY_MODE_OPTIONS.map(item => <el-radio-button key={item.label} label={item.label}>{item.name}</el-radio-button>)}
          </el-radio-group>
        )
      },
      isShow: function () {
        return this.value.visibleRange == 'vip'
      }
    }, {
      label: "内容设置",
      key: "defaultSetting",
      component: function (h, { key }) {
        return (<CompHotSetting v-model={this.value[key]} uuid={this.value.uuid} />)
      },
      value: {
        imgUrl: "", data: [], imgName: '', displayMode: HOT_ZONE_MODE
      },
      isShow: function () {
        if (this.value.visibleRange == 'all') return false;
        if (this.value.visibleRange != 'vip') return true;
        const { defaultSetting = {} } = this.value;
        return (defaultSetting.displayMode || HOT_ZONE_MODE) === HOT_ZONE_MODE;
      }
    },
  ],
  transformIn: async (v) => {
    const {
      name,
      base,
      config,
      data: {
        type,
        isdistinguish,
        visibleRange = 'all',
        defaultSetting = {},
        isCloseable = 'no',
        closeTime = 30,
        vip = {},
        noVip = {},
        ...data
      } = {}
    } = v;
    // 兼容旧的 isdistinguish 字段
    let finalVisibleRange = visibleRange;
    if (isdistinguish !== undefined) {
      finalVisibleRange = isdistinguish === 'no' ? 'vip' : 'all';
    }
    return {
      name,
      ...base,
      ...config,
      visibleRange: finalVisibleRange,
      defaultSetting: {
        imgUrl: "",
        data: [],
        imgName: '',
        displayMode: HOT_ZONE_MODE,
        ...defaultSetting
      },
      isCloseable,
      closeTime,
      data: {
        ...data,
        type: type || 'vip',
        vip: {
          imgUrl: "",
          data: [],
          imgName: '',
          displayMode: HOT_ZONE_MODE,
          ...vip
        },
        noVip: {
          imgUrl: "",
          data: [],
          imgName: '',
          ...noVip
        }
      },
    }
  },
  transformOut: (v) => {
    const { data: { noVip = {}, vip = {} }, floor_var, visibleRange, defaultSetting = {}, isCloseable, closeTime } = v
    if (!floor_var) {
      throw '[挂件]悬浮层 请输入楼层';
    }
    if (visibleRange == 'all') {
      if (noVip.imgUrl && !noVip.flowName_var) {
        throw '[挂件]悬浮层 请输入内容设置-非会员-资源位名称';
      }
      if ((vip.displayMode || HOT_ZONE_MODE) === HOT_ZONE_MODE) {
        if (vip.imgUrl && !vip.flowName_var) {
          throw '[挂件]悬浮层 请输入内容设置-会员-资源位名称';
        }
        for (let i in vip.data || []) {
          if (!vip.data[i].imgName) {
            throw '[挂件]悬浮层 请输入内容设置-会员-热区名称';
          }
        }
      }
      for (let i in noVip.data || []) {
        if (!noVip.data[i].imgName) {
          throw '[挂件]悬浮层 请输入内容设置-非会员-热区名称';
        }
      }
    } else if (visibleRange == 'vip') {
      if ((defaultSetting.displayMode || HOT_ZONE_MODE) === HOT_ZONE_MODE) {
        if (defaultSetting.imgUrl && !defaultSetting.flowName_var) {
          throw '[挂件]悬浮层 请输入内容设置-资源位名称';
        }
        for (let i in defaultSetting.data || []) {
          if (!defaultSetting.data[i].imgName) {
            throw '[挂件]悬浮层 请输入内容设置-热区名称';
          }
        }
      }
    } else {
      if (defaultSetting.imgUrl && !defaultSetting.flowName_var) {
        throw '[挂件]悬浮层 请输入内容设置-资源位名称';
      }
      for (let i in defaultSetting.data || []) {
        if (!defaultSetting.data[i].imgName) {
          throw '[挂件]悬浮层 请输入内容设置-热区名称';
        }
      }
    }
    if (isCloseable == 'yes' && (!closeTime || closeTime < 1)) {
      throw '[挂件]悬浮层 关闭后再次显示时间必须大于0';
    }

    return pickBy(v, {
      name: 'name',
      base: (v) => {
        return pickBy(v, {
          floor_var: "floor_var",
        });
      },
      config: (v) => {
        return pickBy(v, {
          backgroundColor: 'backgroundColor',
          backgroundImage: 'backgroundImage',
          position: 'position',
          distance: 'distance',
          margin: 'margin',
          padding: 'padding',
        });
      },
      data: (v) => {
        return pickBy(v, {
          type: 'data.type',
          vip: "data.vip",
          noVip: 'data.noVip',
          defaultSetting: 'defaultSetting',
          visibleRange: 'visibleRange',
          isCloseable: 'isCloseable',
          closeTime: 'closeTime'
        })
      },
    })
  }
}
